// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "div.secondary-page{text-align:left!important}.simple_banner{border-radius:0}.container-fluid.secondary-page.minimizeWidth{max-width:1400px!important}.whiteBg{background:#fff!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
